/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbRecherchecalendrierVisiteDto } from './FcbRecherchecalendrierVisiteDto';
import {
    FcbRecherchecalendrierVisiteDtoFromJSON,
    FcbRecherchecalendrierVisiteDtoFromJSONTyped,
    FcbRecherchecalendrierVisiteDtoToJSON,
} from './FcbRecherchecalendrierVisiteDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbRecherchecalendrierVisiteDtoPaginatedResults
 */
export interface FcbRecherchecalendrierVisiteDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbRecherchecalendrierVisiteDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbRecherchecalendrierVisiteDto>}
     * @memberof FcbRecherchecalendrierVisiteDtoPaginatedResults
     */
    results?: Array<FcbRecherchecalendrierVisiteDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbRecherchecalendrierVisiteDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbRecherchecalendrierVisiteDtoPaginatedResults interface.
 */
export function instanceOfFcbRecherchecalendrierVisiteDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbRecherchecalendrierVisiteDtoPaginatedResultsFromJSON(json: any): FcbRecherchecalendrierVisiteDtoPaginatedResults {
    return FcbRecherchecalendrierVisiteDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbRecherchecalendrierVisiteDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbRecherchecalendrierVisiteDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbRecherchecalendrierVisiteDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbRecherchecalendrierVisiteDtoPaginatedResultsToJSON(value?: FcbRecherchecalendrierVisiteDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbRecherchecalendrierVisiteDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

